module.exports = __webpack_public_path__ + "img/home_banner_wrap3.9a18f8b9.png";